var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgGoogleTransparent = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.525 8.1875C15.525 10.3958 14.8271 12.2083 13.4313 13.625C12.0563 15.0417 10.2542 15.75 8.025 15.75C5.87917 15.75 4.04583 15 2.525 13.5C1.025 11.9792 0.275 10.1458 0.275 8C0.275 5.85417 1.025 4.03125 2.525 2.53125C4.04583 1.01042 5.87917 0.25 8.025 0.25C10.0458 0.25 11.775 0.927083 13.2125 2.28125L11.1188 4.3125C10.4521 3.66667 9.65 3.29167 8.7125 3.1875C7.79583 3.0625 6.93125 3.17708 6.11875 3.53125C5.32708 3.86458 4.63958 4.4375 4.05625 5.25C3.49375 6.04167 3.2125 6.95833 3.2125 8C3.2125 9.35417 3.68125 10.5104 4.61875 11.4688C5.55625 12.4271 6.69167 12.9062 8.025 12.9062C8.75417 12.9062 9.4 12.7917 9.9625 12.5625C10.5458 12.3125 10.9938 12.0104 11.3063 11.6562C11.6396 11.2812 11.8896 10.9167 12.0563 10.5625C12.2438 10.2083 12.3688 9.875 12.4313 9.5625H8.025V6.875H15.4C15.4833 7.33333 15.525 7.77083 15.525 8.1875Z",
    fill: "#D74149"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogleTransparent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/google_transparent.94ad93e6.svg";
export { ForwardRef as ReactComponent };